import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function BorrowersPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      icon: 'ri-funds-line',
      title: '銀行貸款',
      description: '協助企業向銀行申請各類貸款，包括營運週轉金、設備採購等'
    },
    {
      icon: 'ri-rocket-line',
      title: '創投資金',
      description: '媒合具成長潛力的企業與創投基金，協助企業快速擴張'
    },
    {
      icon: 'ri-building-line',
      title: '私募股權',
      description: '連結私募基金與尋求長期資金的企業，共同成長'
    },
    {
      icon: 'ri-exchange-funds-line',
      title: '融資租賃',
      description: '提供設備融資租賃方案，減輕企業資金壓力'
    },
    {
      icon: 'ri-file-text-line',
      title: '票據融資',
      description: '協助企業進行應收帳款融資，改善現金流'
    },
    {
      icon: 'ri-community-line',
      title: '其他融資',
      description: '依據企業需求，提供客製化的資金解決方案'
    }
  ];

  const fundingStages = [
    {
      stage: '種子期',
      amount: '依需求而定',
      suitable: '產品開發初期、團隊組建階段',
      sources: ['天使投資人', '創業加速器', '政府補助']
    },
    {
      stage: '成長期',
      amount: '依需求而定',
      suitable: '市場拓展、團隊擴充、營運優化',
      sources: ['創投基金', '銀行貸款', '私募基金']
    },
    {
      stage: '擴張期',
      amount: '依需求而定',
      suitable: '多地點展店、併購、大規模投資',
      sources: ['私募基金', '銀行聯貸', '策略投資人']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      <div className="pt-32 pb-24 bg-gradient-to-br from-black to-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-white mb-6">需求方服務</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            為企業提供多元的資金媒合服務，協助企業取得營運所需的資金
          </p>
        </div>
      </div>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/100c5c159885fc3439d6df94e492092b.jpg"
                alt="需求方服務"
                className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
              />
            </div>

            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">我們能為您做什麼？</h2>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                朋睿了解企業在不同發展階段的<strong>資金需求</strong>，無論是創業初期的種子資金、成長期的擴張資金，或是成熟期的營運週轉，我們都能為您媒合適合的<strong>資金來源</strong>。
              </p>
              <p className="text-gray-700 mb-8 leading-relaxed text-lg">
                透過專業的<strong>需求分析</strong>與<strong>財務規劃</strong>，協助企業準備完整的申請文件，提高資金取得的成功率。我們與多家銀行、創投、私募基金建立長期合作關係，能為您找到最適合的資金方案。
              </p>

              <div className="bg-gray-50 rounded-xl p-8 border border-gray-200">
                <h3 className="text-xl font-bold text-gray-900 mb-6">適合的企業類型</h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">中小企業營運週轉</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">新創企業資金募集</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">成長型企業擴張資金</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">製造業設備採購</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">貿易商票據融資</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">連鎖品牌展店資金</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-4 text-center">資金類型</h2>
            <div className="w-20 h-1 bg-black mx-auto mb-12"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-xl transition-shadow"
                >
                  <div className="w-16 h-16 bg-black/10 rounded-lg flex items-center justify-center mb-6">
                    <i className={`${service.icon} text-3xl text-black`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-4 text-center">不同階段的資金需求</h2>
            <div className="w-20 h-1 bg-black mx-auto mb-12"></div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {fundingStages.map((item, index) => (
                <div key={index} className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-black transition-colors">
                  <div className="text-center mb-6">
                    <div className="inline-block px-6 py-2 bg-black/10 rounded-full mb-4">
                      <span className="text-black font-bold text-lg">{item.stage}</span>
                    </div>
                    <div className="text-2xl font-bold text-gray-900 mb-2">{item.amount}</div>
                  </div>
                  
                  <div className="mb-6">
                    <h4 className="text-sm font-bold text-gray-900 mb-2">適用對象</h4>
                    <p className="text-gray-600 text-sm">{item.suitable}</p>
                  </div>
                  
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-3">資金來源</h4>
                    <div className="space-y-2">
                      {item.sources.map((source, idx) => (
                        <div key={idx} className="flex items-center text-sm">
                          <i className="ri-arrow-right-s-line text-black mr-2"></i>
                          <span className="text-gray-600">{source}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-black to-gray-800 rounded-2xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-6">需要資金協助嗎？</h2>
            <p className="text-xl mb-8 text-white/90">
              立即聯繫我們，讓朋睿為您找到最適合的資金方案
            </p>
            <a
              href="https://line.me/R/ti/p/@678gwbht"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 bg-white text-black rounded-full font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-chat-3-line text-2xl mr-3"></i>
              LINE 諮詢
            </a>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* LINE 客服按鈕 */}
      <a
        href="https://line.me/R/ti/p/@678gwbht"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-6 z-40 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-300 group"
        aria-label="LINE 即時諮詢"
      >
        <i className="ri-line-fill text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          LINE 即時諮詢
        </span>
      </a>
    </div>
  );
}
